import Script from "next/script";
import { useState } from "react";
import styled from "styled-components";
import StyledLink from "../../../../shared/components/global/StyledLink";
import { Button, ButtonSizes } from "../../../../shared/styles/button";
import { device } from "../../../../shared/styles/device";

const HeroSection = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  gap: 32px;
  text-align: left;
  padding-top: 32px;
  padding-bottom: 32px;
  @media ${device.tablet} {
    grid-template-columns: 1fr 1fr;
  }

  h1 {
    font-weight: 800;
    font-size: 32px;
    line-height: 42px;
    @media ${device.tablet} {
      line-height: 46px;
    }
    margin-top: 0;
    margin-bottom: 8px;

    span {
      display: block;
      color: ${(props) => props.theme.colors.fontBlack};
    }
  }

  h2 {
    font-size: 24px;
    line-height: 30px;
    margin-top: 0;
    margin-bottom: 32px;

    @media ${device.tablet} {
      font-size: 30px;
      line-height: 40px;
    }
  }

  /*   h2 {
    font-size: 26px;
    line-height: 40px;
    margin-top: 0;
    margin-bottom: 48px;
  } */

  p {
    font-size: 18px;
    line-height: 26px;
    margin-top: 0px;
    margin-bottom: 32px;
    max-width: 700px;
    font-weight: 400;
    @media ${device.tablet} {
      margin-bottom: 48px;
    }
    strong {
      font-weight: 800;
      white-space: nowrap;
    }
  }

  .video-container {
    border-radius: 16px;
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;
    width: 100%;
    margin-bottom: 32px;

    iframe {
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      position: absolute;
    }
  }

  a {
    display: block;
    align-self: center;
  }

  @media ${device.tablet} {
    padding-top: 64px;
    padding-bottom: 64px;
    h1 {
      font-size: 48px;
      line-height: 60px;
      /*             font-size: 56px;
            line-height: 72px; */
    }
    /*         h2 {
            font-size: 42px;
            line-height: 50px;
        } */
    p {
      margin-top: 16px;
      margin-bottom: 32px;
      font-size: 24px;
      line-height: 31px;
    }
    .video-container {
      border-radius: 30px;
      margin-bottom: 32px;
    }
  }
`;

const LogoWrapper = styled.div`
  svg {
    height: 50px;
    width: 50px;
  }

  @media ${device.tablet} {
    svg {
      height: 60px;
      width: 60px;
    }
  }
`;

export const VideoHero = () => {
  const [opacity, setOpacity] = useState(0);

  return (
    <HeroSection>
      <div>
        {/*         <LogoWrapper>
          <TalentpoolLogo />
        </LogoWrapper> */}
        <h1>
          <span>STELL-MICH-EIN</span>
          <span style={{ color: "#FDC228" }}>Speed-Recruiting</span>
        </h1>
        <h2>Finde deinen Traumjob.</h2>
        <p>
          Beim STELL-MICH-EIN lernst du <strong>an einem Abend</strong> etwa{" "}
          <strong>10 Top-Unternehmen</strong> der Kommunikationsbranche kennen.
          <br />
          <br />
          Wie beim klassischen Speed-Dating wechselst du alle{" "}
          <strong>5 Minuten</strong> den Tisch – Schneller kann dein Talent gar
          nicht die Runde machen
          <br />
          <br />
          Schreibe jetzt <strong>1 Bewerbung</strong>, führe{" "}
          <strong>10 Bewerbungsgespräche</strong> mit{" "}
          <strong>Top Agenturen</strong>, erhalte Jobangebote und{" "}
          <strong>finde deinen Traumjob.</strong>
        </p>
        <StyledLink href="/register/talent/">
          <Button primary size={ButtonSizes.m}>
            Jetzt kostenlos registrieren
          </Button>
        </StyledLink>
      </div>

      <div className="video-container">
        {/* <iframe
                    src={`https://www.youtube.com/embed/Huwj8PjIF2A`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Embedded youtube"
                /> */}
        <div className="video-container">
          <Script src="https://fast.wistia.com/embed/medias/cqgk6ljmxu.jsonp" />
          <Script src="https://fast.wistia.com/assets/external/E-v1.js" />

          <div
            className="wistia_responsive_padding"
            style={{ padding: "56.25% 0 0 0", position: "relative" }}
          >
            <div
              className="wistia_responsive_wrapper"
              style={{
                height: "100%",
                position: "absolute",
                left: 0,
                top: 0,
                width: "100%",
              }}
            >
              <div
                className="wistia_embed wistia_async_cqgk6ljmxu videoFoam=true"
                style={{
                  height: "100%",
                  position: "relative",
                  width: "100%",
                }}
              >
                <div
                  className="wistia_swatch"
                  style={{
                    height: "100%",
                    position: "absolute",
                    width: "100%",
                    left: 0,
                    top: 0,
                    opacity: opacity,
                    overflow: "hidden",
                    transition: "opacity 200ms",
                  }}
                >
                  <img
                    src="https://fast.wistia.com/embed/medias/cqgk6ljmxu/swatch"
                    style={{
                      filter: "blur(5px)",
                      objectFit: "contain",
                      height: "100%",
                      width: "100%",
                    }}
                    alt=""
                    aria-hidden="true"
                    onLoad={() => setOpacity(1)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </HeroSection>
  );
};
